import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { ResizeableType, WBComponent } from "./WBComponent";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ColumnIcon } from "../Icons/ComponentIcons";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import React from "react";
import CreateAttributeList, { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import WebDesigner from "../WebDesigner";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";


export default class Column extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.column;
        this.dropList = [wBComponentTypeNames.pageRoot, wBComponentTypeNames.section,wBComponentTypeNames.footer,wBComponentTypeNames.navigationBar];
        this.displayName = "Column";
        this.editList=[ 
 
          attributeTypes.flexDirection,
        
        attributeTypes.alignItems,
        attributeTypes.alignContent,
        attributeTypes.justifyContent,
        attributeTypes.alignContent,
        attributeTypes.maxWidth,
        attributeTypes.minWidth,
        attributeTypes.flexWrap,
        attributeTypes.flexGrow,
        attributeTypes.height,
        ...CreateAttributeList(true,true,true,false,true,false).filter(x=>x!="margin")
     
      ];


      


        this.primaryEditAttributes = [
          attributeTypes.flexGrow,    
          attributeTypes.flexDirection,    
         componentAttributeTypes.fullAlignment,
         attributeTypes.flexWrap,
        attributeTypes.gap,
    
        
        
        ]
        this.resizeType = ResizeableType.VerticalOnly;
        this.resizeVisibilty = [false,false,true];
        this.icon = <ColumnIcon/>

    }




    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
          // if(newParent.typename == wBComponentTypeNames.section||newParent.typename == wBComponentTypeNames.row||newParent.typename == wBComponentTypeNames.navigationBar||newParent.typename == wBComponentTypeNames.footer){
          //   let  dup = super.duplicateSelfOnCreation(newParent,thisLayout,manager);

          //       if(dup){
          //           dup.screenSizeStyleAttributes[ScreenSize.Desktop] = {gap:"4px"};//(ScreenSize.Desktop,attributeTypes.gap,"4px");
          //           dup.componentAttributes = {horizontalAlign:"center",verticalAlign:"center"};
          //       }
          // }
  
    
        thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] =  {gap:"4px",justifyContent:"center",alignItems:"center",alignContent:"center"};

        
    }

    

    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps): JSX.Element {

      const atts = GetNodeDomAttributes("v-col ",component,screenSize,isEditor);
      //const get = atts as any;
      

      return  <div {...atts} >

      {children}

      </div>
      
      // //pass padding down to inner container since flexbox will use padding in final width calculation

      // let padding = get?.style?.padding??""; 

      // if(padding.length>0){
      //    atts.style = {...atts.style,padding:"0px"}
      // }

      // let token = "";
      // let tokens = "";
      // let className = atts.className;
      // let max = 0;
      // while(className.includes("vwb-pdg-")&&max<4){ //should never exceed 3 padding tokens (1 for each screensize)

        

      //   max++;
      //   let start = className.indexOf("vwb-pdg-");
      //   let end = className.indexOf(" ",start+1);
      //   if(end<0){
      //     end = className.length;
      //   }

      //   token = className.substring(start,end);


      //   className = className.replace(token,"");
      //   tokens += token+" ";

      // }

      // atts.className = className;

      //  return  <div {...atts} >
      //       <div className={"inner-column "+tokens} style={(isEditor)?{padding:padding}:{}}>
      //       {children}
      //       </div>
      //       </div>
      
            
    }

    

    onPreDeletion(thisLayout: LayoutNode, manager: WebDesigner): void {
     // super.removeIfOneLastSibling(thisLayout,manager)
     if(thisLayout.parent && thisLayout.parent.typename == wBComponentTypeNames.section && thisLayout.parent.children.length == 1){
        manager.deleteObjectById(thisLayout.parent.id);
     }
    }


   


}



